import { RgShallowClone as n } from "./index29.js";
function i({
  list: t,
  floors: p,
  height: s,
  yStart: e = 0
}) {
  let o = [];
  for (let l = 0; l < p; l++)
    o = o.concat(
      t.map((r) => n({
        ...r,
        pos: [r.pos[0], e + s * l, r.pos[2]]
      }))
    );
  return o;
}
export {
  i as CopyAcrossFloors
};
//# sourceMappingURL=index4.js.map
